import nav from "../home-screen/nav";
import spinner from "../spinner";
import generateHtml from "./generate-html";
import displayListingGenerateHtml from "../display-listing/generate-html";
import firebase from "../firebase";
import signUpProfile from "../sign-up_profile/signUpProfile";
import CTANotifications from "../CTANotifications";
import GENRALHELPERS from "../GENRAL-HELPERS";
import createListing from "../create-listing/create-listing";
import allHandeling from "../handeling-all-displays/all-handeling";


const colors = {
  headerPrimary: "FFFFFF",
  headerSecondary: "E0E0E0",
  packTitles: "6D6D6D",
  packTitlesHighlight: "3A7D44",
  itemBackgroundPrimary: "3A7D44",
  itemBackgroundSecondary: "fff",
  itemTextPrimary: "FFFFFF",
  itemTextSecondary: "2B2B2B",
  itemTextTerteriary: "3A7D44",
  itemTextFour: "3A7D44",
  itemHighlight: "FF7043",
  itemHighlightText: "FFFFFF",
};


const notificationsTest = [{
  title: 'Tenemos una vueva actualización',
  subTitle: 'Nuevas Funciones están disponibles',
  content: 'Ahora puedes disfrutar De funciones como notificaciónes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.',
  read: true
}, {
  title: 'NEW Tenemos una vueva actualización',
  subTitle: 'Nuevas Funciones están disponibles',
  content: 'Ahora puedes disfrutar De funciones como notificaciónes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.',
  read: true
}, {
  title: 'Tenemos una vueva actualización',
  subTitle: 'Nuevas Funciones están disponibles',
  content: 'Ahora puedes disfrutar De funciones como notificaciónes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.',
  read: true
}, {
  title: 'Tenemos una vueva actualización',
  subTitle: 'Nuevas Funciones están disponibles',
  content: 'Ahora puedes disfrutar De funciones como notificaciónes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.',
  read: false
}, {
  title: 'Tenemos una vueva actualización',
  subTitle: 'Nuevas Funciones están disponibles',
  content: 'Ahora puedes disfrutar De funciones como notificaciónes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.',
  read: false
}]


class saved {
  #sortButtonsActived = false;
  #loadedData;
  #notificationEvents = false
  #currentCategory = 'all'
  #notificationLastDoc = null
  #isLoadingNotifications = false
  #hasMoreNotifications = true

  constructor() {

    this._windowEvents();
  }


  _windowEvents() {
    window.addEventListener("click", () => {
      const isNotificationClick = event.target.closest(".nvNotificationCon1");
      if (isNotificationClick) {
        const inAppLink = isNotificationClick.dataset.inapplink
        const inAppLinkType = isNotificationClick.dataset.inapplinktype
        this._handleInAppLinks(inAppLinkType, inAppLink)
      }
    })
  }

  async _handleInAppLinks(inAppLinkType, link) {
    const [p1, p2, p3, p4, p5] = link.split("/");

    if (link === 'postItemForSale') {
      createListing._init()
    }
    if (inAppLinkType === 'openOwnCreatedListing') {
      console.log('Should open listing of current user, listing:', link);



      console.log("Listing uploaded successfully. Should open listing now, and trigger CTA share.");

      let lives = 'seller'
      if (p1 !== 'accounts') {
        lives = 'business'
      }

      await allHandeling._displayTheRightWay(p2, p4, lives, 'publish', false, "aspectRatio_9-6", true)
    }
  }

  // _initializeSwitch(id, callback) {
  //   const switchEl = document.getElementById(id);
  //   if (!switchEl) return;

  //   const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
  //   if (!knob) return;

  //   // Normalize initial state
  //   let state = switchEl.dataset.state === "on";

  //   // Sync UI with state
  //   const syncUI = () => {
  //     knob.classList.toggle("nvNotiSetingsSwitchCon4Act", state);
  //     switchEl.dataset.state = state ? "on" : "off";
  //   };

  //   syncUI();

  //   // Click handler
  //   switchEl.addEventListener("click", () => {
  //     state = !state;
  //     syncUI();

  //     if (typeof callback === "function") {
  //       callback(state);
  //     }
  //   });
  // }

  _initializeSwitch(id, callback, cooldownMs = 2000) {
    const switchEl = document.getElementById(id);
    if (!switchEl) return;

    const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
    if (!knob) return;

    let state = switchEl.dataset.state === "on";
    let locked = false;

    const syncUI = () => {
      knob.classList.toggle("nvNotiSetingsSwitchCon4Act", state);
      switchEl.dataset.state = state ? "on" : "off";
    };

    syncUI();

    switchEl.addEventListener("click", () => {
      if (locked) return; // 🚫 ignore spam clicks

      locked = true;
      state = !state;
      syncUI();

      if (typeof callback === "function") {
        callback(state);
      }

      // 🔓 unlock after cooldown
      setTimeout(() => {
        locked = false;
      }, cooldownMs);
    });
  }


  _reverseSwitch(id) {
    const switchEl = document.getElementById(id);
    if (!switchEl) return;

    const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
    if (!knob) return;

    const isOn = switchEl.dataset.state === "on";
    const newState = !isOn;

    switchEl.dataset.state = newState ? "on" : "off";
    knob.classList.toggle("nvNotiSetingsSwitchCon4Act", newState);
  }




  async _loadSaved() {
    const SavedAndFollowingTextB10UpateMessage = document.getElementById(
      "SavedAndFollowingTextB10UpateMessage"
    );

    this.#sortButtonsActived = false;
    const account = firebase._getLatestCurrentUserData();
    if (!account) {
      SavedAndFollowingTextB10UpateMessage.textContent =
        "Dedes ingresar a tu cuenta para ver tus guardados.";
      return;
    }

    const allPaths = [];
    let activeBusinessFollows = [];
    let savedBusinesses = [];
    let savedListings = [];

    if (account.activeFollows) {
      activeBusinessFollows = account.activeFollows;
    }
    if (account.activeBusinessSaves) {
      savedBusinesses = account.activeBusinessSaves;
    }
    if (account.activeSaves) {
      savedListings = account.activeSaves;
    }

    // Add paths to the allPaths array
    if (activeBusinessFollows.length > 0) {
      activeBusinessFollows.forEach((save) => {
        if (typeof save === "object") {
          allPaths.push(save.path);
        }
        if (typeof save === "string") {
          allPaths.push(save);
        }
      });
    } else {
    }
    if (savedBusinesses.length > 0) {
      savedBusinesses.forEach((save) => {
        if (typeof save === "object") {
          allPaths.push(save.path);
        }
        if (typeof save === "string") {
          allPaths.push(save);
        }
      });
    } else {
    }
    if (savedListings.length > 0) {
      savedListings.forEach((save) => {
        if (typeof save === "object") {
          allPaths.push(save.path);
        }
        if (typeof save === "string") {
          allPaths.push(save);
        }
      });
    } else {
    }

    if (
      !activeBusinessFollows.length > 0 &&
      !savedBusinesses.length > 0 &&
      !savedListings.length > 0
    ) {
      SavedAndFollowingTextB10UpateMessage.textContent =
        "No tienes guardados aún.";
      return;
    }

    const loadedSaves = {
      businesses: [],
      individualListings: [],
    };

    // To track which businesses are loaded
    const loadedBusinessIds = new Set();

    // Sequential loading function for each path
    async function loadData(path) {
      const save = await firebase._getAnyDocById(path);

      // Extract business ID if it's a Type 1 path (businesses/{businessId}/listings/{listingId})
      let businessId = null;
      if (path.startsWith("businesses/")) {
        const parts = path.split("/");
        businessId = parts[1]; // Extract business ID from the path
      }

      // Type 1: Business and listing path (businesses/{businessId}/listings/{listingId})
      if (path.includes("businesses/") && path.includes("/listings/")) {
        // Check if the business is already loaded (businessId)
        if (!loadedBusinessIds.has(businessId)) {
          // Load the business if not already loaded
          const business = await firebase._getAnyDocById(
            `businesses/${businessId}`
          );
          loadedSaves.businesses.push({
            ...business,
            id: businessId, // Ensure you have the `id` property here
            listings: [], // Initialize the listings array
          });

          // Mark this business as loaded
          loadedBusinessIds.add(businessId);
        }

        // Add the listing to the corresponding business
        const business = loadedSaves.businesses.find(
          (b) => b.id === businessId
        );
        business.listings.push(save);
      }
      // Type 2: Individual listing path (listings/{listingId})
      else if (path.startsWith("listings/")) {
        loadedSaves.individualListings.push(save);
      }

      // Type 3: Business path (businesses/{businessId})
      else if (path.startsWith("businesses/")) {
        // Check if the business is already loaded (businessId)
        if (!loadedBusinessIds.has(businessId)) {
          // Load the business if not already loaded
          loadedSaves.businesses.push({
            ...save,
            id: businessId, // Ensure you have the `id` property here
            listings: [], // Initialize the listings array
          });

          // Mark this business as loaded
          loadedBusinessIds.add(businessId);
        }
      }
    }

    // Sequentially process each path one at a time (wait for each to finish before starting the next)
    try {
      // Loop through each path and load the data one by one
      for (let i = 0; i < allPaths.length; i++) {
        await loadData(allPaths[i]); // This ensures each path loads in sequence
      }

      // After all data is loaded, display and finalize
      this.#loadedData = loadedSaves;
      console.warn(this.#loadedData);
      this._displayAllSaved("all");
      this.#sortButtonsActived = true;
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }

  async _loadNotifications(cat) {
    if (this.#isLoadingNotifications) return;
    if (!this.#hasMoreNotifications && cat === this.#currentCategory) return;

    this.#isLoadingNotifications = true;

    const NvNotiConForNotifications = document.getElementById(
      "NvNotiConForNotifications"
    );

    // 🔁 Category changed → reset pagination
    if (cat !== this.#currentCategory) {
      this.#notificationLastDoc = null;
      this.#hasMoreNotifications = true;
      NvNotiConForNotifications.innerHTML = "";
    }

    this.#currentCategory = cat;

    const account = firebase._getLatestCurrentUserData();
    if (!account) {
      signUpProfile._open();
      this.#isLoadingNotifications = false;
      return;
    }

    try {
      const { notifications, lastDoc, hasMore } =
        await firebase._getNotifications(
          `accounts/${account.userId}/notifications`,
          this.#currentCategory,
          this.#notificationLastDoc
        );

      this.#notificationLastDoc = lastDoc;
      this.#hasMoreNotifications = hasMore;

      notifications.forEach((noti) => {

        console.log(noti);
        const subTitle =
          GENRALHELPERS._convertServerTimestampToReadableTime(
            noti.createdAt
          );

        const notiHtml = generateHtml._notification(
          noti.title,
          subTitle,
          noti.body,
          noti.read,
          noti.buttonLabel,
          noti.inAppLink,
          noti?.inAppLinkType || '',
        );

        NvNotiConForNotifications.insertAdjacentHTML(
          "beforeend",
          notiHtml
        );
      });
    } catch (err) {
      console.error("Failed loading notifications:", err);
    } finally {
      this.#isLoadingNotifications = false;
    }
  }


  async _displayAllSaved(display) {
    const dataIn = this.#loadedData;
    const containerForSpecialDiscountListings = document.getElementById(
      "SavedAndFollowingCon9InsertSaved"
    );
    // const SavedAndFollowingTextB10UpateMessage = document.getElementById(
    //   "SavedAndFollowingTextB10UpateMessage"
    // );

    containerForSpecialDiscountListings.innerHTML = "";
    if (display === "all" || display === "businesses") {
      for (const business of dataIn.businesses) {
        console.warn(business);
        let listingsHtml = ``;

        if (business.listings.length < 1 || business.listings[0] === null) {
          listingsHtml +=
            displayListingGenerateHtml._listingVerticalMiniNoListings(
              null,
              "No tines listados guardados en este negocio."
            );
        } else {
          for (const listing of business.listings) {
            listingsHtml +=
              await displayListingGenerateHtml._listingVerticalMini(
                listing,
                business.colors,
                "listingInBusiness",
                business.businessId
              );
          }
        }

        const businessInPackHtml =
          await displayListingGenerateHtml._generateBusiness2v(
            listingsHtml,
            business
          );
        let isInSearch = false;

        if (isInSearch) {
          return businessInPackHtml;
        } else {
          // console.warn("html", businessInPackHtml);
          containerForSpecialDiscountListings.insertAdjacentHTML(
            "beforeend",
            businessInPackHtml
          );
        }
      }
    }
    if (display === "all" || display === "listings") {
      for (const listing of dataIn.individualListings) {
        console.log(dataIn);
        const html = await displayListingGenerateHtml._listingHorizontal(
          listing,
          colors,
          "listing"
        );
        containerForSpecialDiscountListings.insertAdjacentHTML(
          "beforeend",
          html
        );
      }
    }
  }

  async _open() {
    spinner._hideSpinner();
    this._displayRightNavWindow();
    this._setContent();
    this._loadSaved();
  }


  async _openNotifications() {
    this.#currentCategory = 'all'
    this.#notificationLastDoc = null
    this.#isLoadingNotifications = false
    this.#hasMoreNotifications = true
    this.#notificationEvents = false

    // 🧹 Cleanup
    setTimeout(() => {
      localStorage.removeItem('openNotification');
    }, 1000);


    this._displayRightNavWindow();
    await this._setContent('noti');
    this._loadNotifications('all');
    this._notificationEvents()
    this._initializeSwitch('nvNotiSetingsSwitchAll', async (state) => {
      console.log('Notifications all switch state:', state);
      let result

      spinner._displaySpinner('Actualizando configuración...')
      if (state) {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'all', state: 'remove' })
      } else {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'all', state: 'add' })
      }

      if (!result.data.success) {
        alert(result.data.message)
        this._reverseSwitch('nvNotiSetingsSwitchAll')
      }
      spinner._hideSpinner()


      // Here you can add code to handle the switch state change
    });
    this._initializeSwitch('nvNotiSetingsSwitchImportant', async (state) => {
      console.log('Notifications Important switch state:', state);
      let result

      spinner._displaySpinner('Actualizando configuración...')
      if (state) {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'important', state: 'remove' })
      } else {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'important', state: 'add' })
      }

      if (!result.data.success) {
        alert(result.data.message)
        this._reverseSwitch('nvNotiSetingsSwitchImportant')
      }
      spinner._hideSpinner()


      // Here you can add code to handle the switch state change
    });
    this._initializeSwitch('nvNotiSetingsSwitchPromotion', async (state) => {
      console.log('Notifications Promotion switch state:', state);
      let result

      spinner._displaySpinner('Actualizando configuración...')
      if (state) {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'promotional', state: 'remove' })
      } else {
        result = await firebase._NVWUpdateNotiSetBlockedCat({ category: 'promotional', state: 'add' })
      }

      if (!result.data.success) {
        alert(result.data.message)
        this._reverseSwitch('nvNotiSetingsSwitchPromotion')
      }
      spinner._hideSpinner()


      // Here you can add code to handle the switch state change
    });

    setTimeout(() => {
      // CTANotifications._initializePushNotifications()
      CTANotifications.init()
    }, 500);
  }

  _displayRightNavWindow() {
    const windows = document.querySelectorAll(
      ".MainAppConWithNavigationContentCon"
    );

    windows.forEach((window) => {
      if (window.id === "MainAppConWithNavigationContentConSaved") {
        window.style.display = "flex";
      } else {
        window.style.display = "none";
      }
    });
  }

  async _setContent(what) {
    const HomeScreenContenConForAll = document.getElementById(
      "MainAppConWithNavigationContentConSaved"
    );
    HomeScreenContenConForAll.style.paddingTop = "0px";
    HomeScreenContenConForAll.innerHTML = "";

    if (what === 'noti') {
      HomeScreenContenConForAll.innerHTML = await generateHtml._noti();
    } else {
      HomeScreenContenConForAll.innerHTML = generateHtml._main();
      this._events();
    }
  }


  _notificationEvents() {
    console.log('here')

    if (this.#notificationEvents) return
    this.#notificationEvents = true


    const nvNotiSelectorMainConButtonSettings = document.getElementById('nvNotiSelectorMainConButtonSettings')
    const nvNotiSetingsConainerButtonBack = document.getElementById('nvNotiSetingsConainerButtonBack')
    const nvNotiSetingsConainerMainCon = document.getElementById('nvNotiSetingsConainerMainCon')
    const nvNotiSetingsContainerCon15 = document.getElementById('nvNotiSetingsContainerCon15')

    nvNotiSetingsConainerButtonBack.addEventListener('click', () => {
      nvNotiSetingsConainerMainCon.style.display = 'none'
      nav._show()
    })

    nvNotiSelectorMainConButtonSettings.addEventListener('click', async () => {
      nvNotiSetingsConainerMainCon.style.display = 'flex'
      spinner._displaySpinner('Cargando dispositivos...')
      nvNotiSetingsContainerCon15.innerHTML = await generateHtml._genDevicesHtml()

      nav._hide()
      spinner._hideSpinner()
    })

    nvNotiSetingsConainerMainCon.addEventListener('click', async (e) => {
      const deleteDeviceBtn = e.target.closest('.nvNotiSetingsDeviceCon7')
      const editDeviceBtn = e.target.closest('.nvNotiSetingsDeviceCon8')

      if (deleteDeviceBtn) {
        const deviceToken = e.target.closest('.nvNotiSetingsDeviceCon1').dataset.device
        if (!deviceToken) return


        console.log('delete device:', deviceToken)

        const confirmDelete = confirm('¿Estás seguro de que deseas eliminar este dispositivo? Ya no recibirás notificaciones en este dispositivo.')

        if (!confirmDelete) return
        spinner._displaySpinner('Eliminando dispositivo...')



        let result = await firebase._NVWUpdateDeleteDevice({ token: deviceToken, state: 'delete' })

        if (!result.data.success) {
          alert(result.data.message)
          spinner._hideSpinner()
          return
        }

        // Remove device from UI
        const deviceEl = document.querySelector(`.nvNotiSetingsDeviceCon1[data-device="${deviceToken}"]`);
        if (deviceEl) {
          deviceEl.remove();
        }

        spinner._hideSpinner()
      }

      if (editDeviceBtn) {
        const device = e.target.closest('.nvNotiSetingsDeviceCon1')
        console.log('device:', device)
        if (!device) return
        const deviceToken = device.dataset.device
        console.log('token:', deviceToken)
        if (!deviceToken) return

        const input = device.querySelector('.nvNotiSetingsDeviceCon2 .nvNotiSetingsDeviceCon5')
        if (!input) return
        const name = input.value.trim()
        console.log('name:', name)
        if (!name || name.length < 3) {
          alert('El nombre del dispositivo debe tener al menos 3 caracteres.')
          return
        }

        console.log('edit device:', deviceToken)

        spinner._displaySpinner('Actualizando nombre del dispositivo...')

        let result = await firebase._NVWUpdateDeleteDevice({ token: deviceToken, state: 'update', data: { name: name } })

        if (!result.data.success) {
          alert(result.data.message)
          spinner._hideSpinner()
          return
        }

        input.value = name;

        spinner._hideSpinner()

      }


    })

    // Exicutable functions
    const catSelectorActivate = () => {
      console.log('here')
      const nvNotiConainerCatSelectorCon1 = document.getElementById('nvNotiConainerCatSelectorCon1')
      const allCatSelectors = nvNotiConainerCatSelectorCon1.querySelectorAll('.nvNotiConainerCatSelectorCon2')

      console.log(nvNotiConainerCatSelectorCon1, allCatSelectors)
      allCatSelectors.forEach(catE => {
        console.log('here')
        catE.addEventListener('click', () => {
          const category = catE.dataset.cat
          if (!category) return

          this._loadNotifications(category);

          console.log('click')
          allCatSelectors.forEach(cat => { cat.classList.remove('nvNotiConainerCatSelectorCon2Act') })
          catE.classList.add('nvNotiConainerCatSelectorCon2Act')
        })
      })
    }
    catSelectorActivate()


    const container = document.getElementById(
      "NvNotiConForNotificationsScroll"
    );

    console.log('container:', container)

    if (!container) return;

    container.addEventListener("scroll", () => {
      if (this.#isLoadingNotifications) return;
      if (!this.#hasMoreNotifications) return;

      const threshold = 120; // px from bottom
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        this._loadNotifications(this.#currentCategory);
      }
    });
  }

  _events() {
    const SavedConMainSavedButtonSortAll = document.getElementById(
      "SavedConMainSavedButtonSortAll"
    );
    const SavedConMainSavedButtonSortBusiness = document.getElementById(
      "SavedConMainSavedButtonSortBusiness"
    );
    const SavedConMainSavedButtonSortListings = document.getElementById(
      "SavedConMainSavedButtonSortListings"
    );
    const SavedConMainSavedButtonSortFollowing = document.getElementById(
      "SavedConMainSavedButtonSortFollowing"
    );
    SavedConMainSavedButtonSortAll.addEventListener("click", () => {
      if (!this.#sortButtonsActived) return;
      this._displayAllSaved("all");
    });
    SavedConMainSavedButtonSortBusiness.addEventListener("click", () => {
      if (!this.#sortButtonsActived) return;
      this._displayAllSaved("businesses");
    });
    SavedConMainSavedButtonSortListings.addEventListener("click", () => {
      if (!this.#sortButtonsActived) return;
      this._displayAllSaved("listings");
    });
  }
}
export default new saved();
